import { Modal, Button } from 'Shared/components';

type DeleteMapModalType = {
  uuid: any;
  close: any;
  handleGetStudyAnswerList: any;
  deleteMap: any;
};

const DeleteMapModal = ({ uuid, close, handleGetStudyAnswerList, deleteMap }: DeleteMapModalType) => {
  const handleDeleteMap = async () => {
    await deleteMap(uuid);
    await handleGetStudyAnswerList();
    close();
  };

  return (
    <Modal
      className="top-bar__end-map-modal"
      isOpen={uuid}
      onClose={() => {
        close();
      }}>
      <div className="modal-heading">Usuwanie mapy</div>
      <div className="modal-description  modal-description--full">Czy na pewno chcesz usunąć mapę?</div>
      <div className="top-bar__end-map-modal__buttons">
        <Button label="Anuluj" stroke onClick={() => close()} />
        <Button label="Usuń" onClick={() => handleDeleteMap()} />
      </div>
    </Modal>
  );
};

export default DeleteMapModal;
